export default "__VITE_ASSET__BLh2G44P__"